module.exports = __webpack_public_path__ + "images/fifth_anniversary_modal/modal-img_8af258d1d716645768d395fe9c16dfb8.png";